import React, { Component } from 'react';
import { connect } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import InviteViaTexModal from '../../../components/inviteTextModal/invite-via-textModal';
import MobileSidebar from '../../../components/sidebar/sideBar';
import 'react-phone-input-2/lib/style.css';
import { Scrollbars } from 'react-custom-scrollbars-2';
import MobileSectionheaderWrapper from './styles/m-sectionheader.style';
import { Menu, Dropdown, Modal, notification } from 'antd';
import PermissionBox from '../../permissionBox/permissionBox';
import UserDetails from '../../userDetails/userDetails';
import { VideoProvider } from '../../../components/VideoProvider';
import {getInitials} from '../../../utils/fetchImageUtils'
import Loader from '../../../components/Loader/loader';
import * as UserActions from '../../../actions/contacts';
import * as DeviceDetails from '../../../utils/deviceDetails';
import * as UserApis from '../../../apis/user'

const connectionOptions  = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };


class MobileSectionHeader extends Component {
	constructor(props) {
		super(props);
		this.state={
			isDropdown:false,
			openSidebar:false,
			visible:false,
			showLocalVideo: false,
			joinVideoRoomDropdown:false,
			userList: [],
			recentUserList: [],
			searchText: '',
			showLoader: false,
			showInviteModal: false,
		}
		this.handleClick=this.handleClick.bind(this);
		this.handleOutsideClick=this.handleOutsideClick.bind(this);
		this.OpenSidebar=this.OpenSidebar.bind(this);
		this.closeSidebar=this.closeSidebar.bind(this);
		this.showUserDetailModal=this.showUserDetailModal.bind(this);
	}

	componentDidMount(){
		const { dispatch, match } = this.props;
		//document.addEventListener('click', this.handleOutsideClick);

		const deviceBrowser = DeviceDetails.getBrowser();
		if(deviceBrowser && ["chrome", "safari"].indexOf(deviceBrowser.toLowerCase()) !== -1){
			this.setState({
				warningVisible: false
			})
		}
		dispatch(UserActions.getUserContactList())
	}




	verifyUser = () => {
		this.setState({
			showLocalVideo: true
		});
	}


	handleClick() {
		if (!this.state.isDropdown) {
		  document.addEventListener('click', this.handleOutsideClick, false);
		} else {
		  document.removeEventListener('click', this.handleOutsideClick, false);
		}
		this.setState(prevState => ({
		  isDropdown: !prevState.isDropdown,
		}));
	  }
	
	handleOutsideClick(e) {
	if (this.node.contains(e.target)) {
		return;
	}
	this.handleClick();
	}
		
	OpenSidebar(){
		this.setState({
			openSidebar:true
		});   
	}

	closeSidebar() {
		this.setState({ openSidebar: false });	
	}

	showUserDetailModal() {
		this.setState({
		  visible: true,
		});
	  };
	
	hideUserDetailModal = e => {
		this.setState({
		  visible: false,
		});
	  };



	  onFieldUpdate = async (val) => {

		if (val.length > 2) {
			
			  let reqObject = {
				  "search": val
			  }
			  
			  const response = await UserApis.getUserList(reqObject);
			  if (response.data)
				  this.setState({ userList: response.data, searchText:val })
		  } else {
			this.setState({ searchText:val})
		  }

	  }

	  onRoomLinkUpdate = async (val) => {
			this.setState({ roomLink:val})
	  }

	  openInviteModal = () => {
		const {showInviteModal} = this.state
		this.setState(prevState => ({
			showInviteModal: !prevState.showInviteModal,
			joinVideoRoomDropdown: false
		}))
	  }


	  fetchUsers = async () => {
		const {userList, recentUserList, joinVideoRoomDropdown, searchText} = this.state
		this.setState(prevState => ({
			joinVideoRoomDropdown: !prevState.joinVideoRoomDropdown,
			showInviteModal:false
		}))

		if(joinVideoRoomDropdown == true) return
		this.setState(prevState => ({
			showLoader:true
		}))

		if (!userList || userList.length == 0) {
			let reqObject = {
				"search": searchText
			}

			const response = await UserApis.getUserList(reqObject);
			if(response.data)
				this.setState({userList: response.data})
		}

		if (!recentUserList || recentUserList.length == 0) {
			const response = await UserApis.getRecentUserList();
			if(response.data){
				// let reversedResponseData = response.data.reverse()
				let newUserList = []
				for(let i in response.data){
					if(i < 15){
						newUserList.push(response.data[i])
					} else {
						break
					}
				}
				this.setState({recentUserList: newUserList})
			}
		}

		this.setState({showLoader: false})

	}

	joinRoom = (user) => {
		window.location.assign(`/videoRoom/${user.roomID}`);
	}
	joinRoomFromLink = () => {
		let { roomLink } = this.state
		if(!roomLink || roomLink == ''){
			notification['error']({
                message: 'Error',
                description: 'Please enter the Video Room link',
            });
			return
		}

		let count = 0
		if(roomLink.includes('/')){
			let splittedArray = roomLink.split('/');
			roomLink = splittedArray[splittedArray.length-1]
		}
		window.location.assign(`/videoRoom/${roomLink}`);
	}

	hideModal = () => {
		this.setState({joinVideoRoomDropdown: false, isDropdown: false, showInviteModal: false})
	}



	render() {
		const { setting, therapistRoom, contact } = this.props;
		const { currentUser } = setting;
		const userName = currentUser.firstName + " " + currentUser.lastName;
		const { openEmailLink, copyToClipBoard, openInviteModal } = this.props;
		const { userList, recentUserList, searchText, showLoader} = this.state

		let camName = "";
		if(currentUser && currentUser.firstName){
			camName = currentUser.firstName + " " + currentUser.lastName;
		}
		let contactsList = contact.contacts? contact.contacts : []
		if(!searchText || searchText == '' || searchText.length < 3){
			if(searchText.length){
				contactsList = contact.contacts.filter(contact => (contact.firstName + " " + contact.lastName).toLowerCase().includes(searchText.toLowerCase()))
			}
		}

		if(searchText && searchText.length >= 3){
			contactsList = contact.contacts.filter(contact => (contact.firstName + " " + contact.lastName).toLowerCase().includes(searchText.toLowerCase()))
			if(userList){
				for(let i of userList){
					if(!contactsList.some(contact => contact.mobileNumber == i.mobileNumber)){
						let hideNumber = (currentUser && currentUser.isPatient && currentUser.isPatient == true)? true : false

						let contactItem = {
							...i,
							hideNumber: hideNumber
						}
						contactsList.push(contactItem)
					}
					
				}
			}

		}

		// const menu = (
		// 	<Menu className="invite-dropdown">
		// 	  <Menu.Item key="0" onClick={openInviteModal}>
		// 		Text Message
		// 	  </Menu.Item>
		// 	  <Menu.Divider />
		// 	  <Menu.Item key="1" onClick={openEmailLink}>
		// 		Email
		// 	  </Menu.Item>
		// 	</Menu>
		//   );

		const inviteMenu = (
			<Menu className="invite-dropdown">
				<Menu.Item key="0">
					<div className="phonefield copy-field">
						<input className="copylink-textbox" readOnly id="phone" name="phone" value={window.location.href} type="text" />
						<span type="button" className="copylink" onClick={copyToClipBoard} ></span>
					</div>
					<button type="button" className="button-el fill copylink" onClick={copyToClipBoard} >COPY LINK</button>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key="1" onClick={openInviteModal}>
					<button type="button" className="button-el copylink" >Invite via Text Message</button>
				</Menu.Item>
				<Menu.Item key="2" onClick={openEmailLink}>
					<button type="button" className="button-el copylink" >Invite via Email</button>
				</Menu.Item>
			</Menu>
		);

		const joinRoomMenu = (
			<Menu className="invite-dropdown" style={{ width: 380 }}>
				<Menu.Item key="3">
					<div className="phonefield video-room-field">
						<input className="video-room-textbox"  id="phone" name="phone" type="text" placeholder="Video Room Link" onChange={(e) => this.onRoomLinkUpdate(e.target.value)} />
					</div>
					<button type="button" className="button-el fill navy copylink text-uppercase"  onClick={()=> this.joinRoomFromLink()}>join video room</button>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item key="4">
					<div className="join_room_content">
						{showLoader == true ?
						<div className="_loader"><Loader /></div>
						:
						<>
						<div className="search_people">
							<input type="search" placeholder="Search People" onChange={e => this.onFieldUpdate(e.target.value)} />
						</div>
						<div className="recent_joinees">
							<Scrollbars style={{ height:75 }}>
							<ul>
								{recentUserList && recentUserList.map( user => 
									<li>
										<div className="_profile" onClick={()=> this.joinRoom(user)}>
											{user.profilePictureUrl ?
												<div className="_profile_picture"><img src={user.profilePictureUrl} /></div> :
											<abbr>{getInitials(user.firstName + " " + user.firstName)}</abbr>
											}
											
											<div className="_name" title="Victoria Flanagan-Grimsrud">{user.firstName} {user.lastName} </div>
										</div>
									</li>
								)}
								{/* <li>
									<div className="_profile">
										<abbr>vf</abbr>
										<div className="_name" title="Victoria Flanagan-Grimsrud">Victoria Flanagan-Grimsrud</div>
									</div>
								</li>
								<li>
									<div className="_profile">
										<img src="https://preview.compleatkidz.com/uploads/teams/user-1665764334.png" />
										<div className="_name" title="Nikita Bagrodia">Nikita Bagrodia</div>
									</div>
								</li> */}
							</ul>
							</Scrollbars>
						</div>
						
						<div className="search_list">
							<Scrollbars>
								<div className="scrollable-content">
									<ul>
										{contactsList && contactsList.map(user =>
											<li key={user.id}>
												<div className="_profile_wrapper">
													{ user.profilePictureUrl ?
														<span><img src={user.profilePictureUrl} /></span>
														:
														<abbr>{getInitials(user.firstName + " " + user.lastName)}</abbr>
													}
													 
													<div className="_profile">
														<h2>{user.firstName} {user.lastName}</h2>
														{/* {(!user.hideNumber) && <h3>{user.mobileNumber}</h3>} */}
													</div>
												</div>
												<button className="join_btn" onClick={()=> this.joinRoom(user)}>join</button>
											</li>
										)}
									</ul>
								</div>
							</Scrollbars>
						</div>
						</>				
						}
					</div>
				</Menu.Item>
			</Menu>
			
		);
		return (
			<MobileSectionheaderWrapper>
			<div className="headerWrapper"> 
			<header className="sectionHeader">
				<div className="menu-icon" onClick={this.OpenSidebar}>
				<span id="notification-sign"></span>	
				<span></span><span></span><span></span>
				</div>
				<div className="m-logo">
				<a><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
				<h3>video room</h3>
				</div>
				<div ref={node => { this.node = node; }} className="user-profile-info">
                      <div className="user__profile">
                          <div className="thumb-inner">
                          {<img onClick={this.showUserDetailModal} src={currentUser.profilePictureUrl !== "" && currentUser.profilePictureUrl.includes('http') ? currentUser.profilePictureUrl : 
						  			"https://static.sendbird.com/sample/profiles/profile_35_512px.png"}/>}
							<Modal
								className="userDetailModal"
								onOk={this.handleOk}
								visible={this.state.visible}
								onCancel={this.hideUserDetailModal}
								footer=""
								>
								<UserDetails currentUser={currentUser} therapistRoom={therapistRoom}/>
								</Modal>
							<span className="down_arrow"><img src="/images/down-arrow-white.png" width="15" /></span>		  
                          </div>
                     </div>
				</div>				
				{/* <div className="top-bar">
					<h1>To invite someone to your waiting room, share this link:</h1>
					
				</div> */}
				</header>
				{(this.state.joinVideoRoomDropdown == true || this.state.showInviteModal == true) && <div className="_overlay" onClick={() => this.hideModal()}></div>}
				<VideoProvider options={connectionOptions}>
					<PermissionBox camName={camName}  showLocalVideo={this.state.showLocalVideo} verifyUser={this.verifyUser}/>
				</VideoProvider>
				<div className="linkRow">
				
				<div className="linkRow-container">
				<div className="textBoxCont">
				<h1>To invite someone to your waiting room, share this link:</h1>
					{/* <div className="phonefield">
							<input className="copylink-textbox" readOnly id="phone" name="phone" value={window.location.href} type="text" />
							<button type="button" className="copylink" onClick={copyToClipBoard} >copy link</button>
					</div> */}
				</div>
					{/* <div className="invite-source">
						<Dropdown overlay={menu} trigger={['click']}>
							<button className="invite-via">invite via</button>
						</Dropdown>
					</div> */}
					<div className="invite-source">
					<Dropdown onClick={() => {
									this.openInviteModal()
								}} visible={this.state.showInviteModal}
									overlayClassName="dropdown-invite"
									overlay={inviteMenu} trigger={['click']}>
									<button className="invite-via">Invite to your video room</button>
								</Dropdown>
					</div>
					<div className="invite-source">
					<Dropdown overlayClassName="dropdown-invite" onClick={() => {
									this.fetchUsers()
								}} visible={this.state.joinVideoRoomDropdown} overlay={joinRoomMenu} trigger={['click']}>
									<button className="invite-via">JOIN A VIDEO ROOM</button>
								</Dropdown>
					</div>
				</div>
				</div>

					<MobileSidebar openSidebar={this.state.openSidebar} closeSidebar={this.closeSidebar}  />
					</div>
			</MobileSectionheaderWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(MobileSectionHeader);
